import React, {createContext, FC, useState} from "react";

// whether the map view of the property page is shown
export const MapContext = createContext<[boolean, React.Dispatch<boolean>]>([
  null!,
  () => null,
]);

export const MapContextProvider: FC = ({ children }) => {
  const [showMap, setShowMap] = useState<boolean>(false);
  return (
    <MapContext.Provider value={[showMap, setShowMap]}>
      {children}
    </MapContext.Provider>
  );
};

// whether the map view of the building area page is shown
export const MapContextBuildingArea = createContext<[boolean, React.Dispatch<boolean>]>([
  null!,
  () => null,
]);

export const MapContextProviderBuildingArea: FC = ({ children }) => {
  const [showMapBuildingArea, setShowMapBuildingArea] = useState(false);
  return (
    <MapContextBuildingArea.Provider value={[showMapBuildingArea, setShowMapBuildingArea]}>
      {children}
    </MapContextBuildingArea.Provider>
  );
};
